/** `inputType` is not part of `SaleFormInputRequest`; it is sent anyway, as it always was. */
export interface FormInputValue {
  hash: string;
  value: string;
  inputType: string;
}

/** The lifecycle of a required form inputs collection, shared by the order and the sale slices. */
export const FormInputsState = {
  Pending: 'pending',
  Sending: 'sending',
  Completed: 'completed',
} as const;

export type FormInputsState = (typeof FormInputsState)[keyof typeof FormInputsState];
